define([
	"dojo/_base/declare",
	"csi/resolver",
	"csi/table/MoveFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/StructureItemMixin",
	"./_StyleWizardMixIn"
], function(declare, resolver, MoveFrom, ActionControllerMixin, xml, Query, StructureItemMixin, _StyleWizardMixIn) {

	return declare([MoveFrom, StructureItemMixin, ActionControllerMixin, _StyleWizardMixIn], {
		defaultsAttribute: "StyleType",
		idWizardResource: "MoveStyle",

		// this controller class will take over and process the hierarchy form appropriately
		processHierarchyForm: false,

		/**
		 *@override
		 * Preselect the heirarchy Fields
		 */
		onWizardViewCreate: function(wizard, page, view) {
			var index = wizard.getIndexOfPage(page);

			if (index == 1) {
				const hierarchyNode = this.widget.getViewNode();
				view.populateHierarchyField(hierarchyNode);
			}
		},

		/**
		 * @override
		 * Set selection is required
		 */
		getFormData: function() {
			const fd = this.inherited(arguments);
			fd.m_bRequireOne = true;

			return fd;
		},

		/**
		 * @override
		 *  apply the filter so that only show the styles which are not part of the current hierarchy
		 */
		getWizardViewQuery: function(wizard, view, index) {
			let q;

			if (index == 0) {
				const {$Type, $URL} = this.widget.getViewNode();
				const id = this.TypeRelations[$Type];
				if (id) {
					q = new Query();
					q.RefAttr(this.TypeRelations[$Type], xml.OP_NOT_EQUALS, $URL);
				}
			}

			return q;
		},

		_getViewFilters: function() {
			// summary: return initial filters for popup view
			var url = this._resolveStyleType(this.getParent());
			if (url) {
				var styleType = resolver.resolveNode(url);
				this.m_cache.cacheNode(styleType);
				return new Query().Attr("Node Name", xml.OP_EQUALS, styleType.$Name, "Child:ProductType").getElements();
			}

			return null;
		},

		/**
		 *@override
		 * Issue request
		 */
		process: function() {
			// specify the parent url so that the parent node can be handled on the server side as expected
			const fd = this.m_formData;
			const hierarchyNode = fd.getParent();

			// in the case of Collection level, all the information is there
			if (hierarchyNode.$Type != "Collection") {
				this.m_urlParent = fd.getFieldValue("Collection", true);

				// Don't publish the unnecessary Fields
				this._ignoreUnnecessaryFieldValues();
			}

			this.inherited(arguments);
		},

		/** 
		 * @override
		 * Remove the new selected items from the table store so that they can go above at the top of table
		 */
		_newPostProcess: function(bInsert) {
			const nodes = this.getNewNodes();
			const {widget} = this;

			nodes.forEach(node => {
				widget.removeResultWithId(node.$URL);
			});

			this.inherited(arguments);
		}
	});
});